<template>
  <div id="favoriteList">
    <b-container class="bv-example-row">
      <div style="padding-top: 2%">
        <div class="container-title-page">
          <div class="box-text-content-title">
            <h2>MES FAVORIS</h2>
            <p>
              <strong>
                Retrouvez tous vos circuits et articles de blogues favoris,
                réunis à un même endroit!
              </strong>
            </p>
          </div>
        </div>
        <div class="container-tabs-menu center-text">
          <a :class="classSelect.circuits" @click="changeMode('circuits')">
            <img src="../assets/circuit_favori.svg" />
            Circuits favoris
          </a>
          <a :class="classSelect.articles" @click="changeMode('articles')">
            <img src="../assets/articles_favoris.svg" />
            Articles favoris
          </a>
          <a :class="classSelect.also" @click="changeMode('also')">
            <img src="../assets/vous_aimeriez_pt.svg" />
            Vous aimeriez peut-être
          </a>
        </div>
        <div v-if="mode === 'circuits'">
          <div class="contents-profils-form active-tabs">
            <div v-for="(info, i) in infoCircuit" :key="i">
              <div class="title-sections-form">
                <p>{{ info.titre }}</p>
              </div>
              <div v-for="(trip, index) in info.trip" :key="index">
                <div class="row-reservation">
                  <div class="depart-by-date trip" @click="changeUrl(trip.url)">
                    <div
                      class="depart-logo"
                      :style="{
                        background: 'url(' + trip.image + ')',
                        backgroundPosition: 'center center',
                      }"
                    ></div>

                    <div class="depart-infos">
                      <div
                        class="depart-title"
                        :style="{ color: trip.couleur }"
                      >
                        {{ trip.titre }}
                      </div>
                      <div class="depart-sub-title">
                        {{ trip.sousTitre }}<br />
                      </div>

                      <ul class="incontournables">
                        <li
                          v-for="(
                            Incontournable, index
                          ) in trip.incontournables"
                          :key="index"
                        >
                          {{ Incontournable }}
                        </li>
                      </ul>

                      <div class="depart-date">
                        <div
                          class="depart-title"
                          :style="{ color: trip.Elem_Couleur }"
                        >
                          Date de départ :
                        </div>
                        <ul class="list-depart">
                          <li style="width: 100%">
                            <a :href="trip.url">
                              {{ trip.dates }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="depart-infos-bottom">
                      <span style="color: #20c6e8" class="demande-partage">{{
                        trip.demandePartage
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="mode === 'articles'">
          <div class="contents-profils-form active-tabs">
            <div v-for="(info, i) in infoArticles" :key="i">
              <div class="title-sections-form">
                <p>{{ info.titre }}</p>
              </div>
              <div class="row-articles">
                <div
                  class="content-article"
                  v-for="(trip, index) in info.trip"
                  :key="index"
                  @click="changeUrl(trip.url)"
                >
                  <div class="img-article">
                    <img :src="trip.image" />
                  </div>
                  <div class="article-info">
                    <div class="article-auteur">
                      <span>{{ trip.author }}</span>
                      <span>{{ trip.date }}</span>
                    </div>
                    <div class="article-title">
                      <h3>{{ trip.title }}</h3>
                    </div>
                    <p class="article-description">
                      {{ trip.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="mode === 'also'">
          <div class="contents-profils-form active-tabs">
            <div class="title-sections-form">
              <p>circuits</p>
            </div>
            <div v-for="(trip, index) in propositionCircuit" :key="index">
              <div class="row-reservation">
                <div class="depart-by-date trip" @click="changeUrl(trip.url)">
                  <div
                    class="depart-logo"
                    :style="{
                      background: 'url(' + trip.image + ')',
                      backgroundPosition: 'center center',
                    }"
                  ></div>

                  <div class="depart-infos">
                    <div class="depart-title" :style="{ color: trip.couleur }">
                      {{ trip.titre }}
                    </div>
                    <div class="depart-sub-title">
                      {{ trip.sousTitre }}<br />
                    </div>

                    <ul class="incontournables">
                      <li
                        v-for="(Incontournable, index) in trip.incontournables"
                        :key="index"
                      >
                        {{ Incontournable }}
                      </li>
                    </ul>

                    <div class="depart-date">
                      <div
                        class="depart-title"
                        :style="{ color: trip.Elem_Couleur }"
                      >
                        Date de départ :
                      </div>
                      <ul class="list-depart">
                        <li style="width: 100%">
                          <a :href="trip.url">
                            {{ trip.dates }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="depart-infos-bottom">
                    <span style="color: #20c6e8" class="demande-partage">{{
                      trip.demandePartage
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="title-sections-form">
              <p>Articles</p>
            </div>
            <div class="row-articles">
              <div
                class="content-article"
                v-for="(trip, index) in propositionArticles"
                :key="index"
                @click="changeUrl(trip.url)"
              >
                <div class="img-article">
                  <img :src="trip.image" />
                </div>
                <div class="article-info">
                  <div class="article-auteur">
                    <span>{{ trip.author }}</span>
                    <span>{{ trip.date }}</span>
                  </div>
                  <div class="article-title">
                    <h3>{{ trip.title }}</h3>
                  </div>
                  <p class="article-description">
                    {{ trip.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="title-sections-form">
              <p>Dernières chances</p>
            </div>
            <div v-for="(trip, index) in propositionDerniere" :key="index">
              <div class="row-reservation">
                <div class="depart-by-date trip" @click="changeUrl(trip.url)">
                  <div
                    class="depart-logo"
                    :style="{
                      background: 'url(' + trip.image + ')',
                      backgroundPosition: 'center center',
                    }"
                  >
                    <div class="box-place-dispo">
                      <div
                        class="depart-places-dispo"
                        style="background: #bab65b"
                      >
                        {{ trip.derniereChance }}
                      </div>
                      <div class="depart-places-dispo-image plurial"></div>
                      <div class="depart-places-dispo-image-tag"></div>
                    </div>
                  </div>

                  <div class="depart-infos">
                    <div class="depart-title" :style="{ color: trip.couleur }">
                      {{ trip.titre }}
                    </div>
                    <div class="depart-sub-title">
                      {{ trip.sousTitre }}<br />
                    </div>

                    <ul class="incontournables">
                      <li
                        v-for="(Incontournable, index) in trip.incontournables"
                        :key="index"
                      >
                        {{ Incontournable }}
                      </li>
                    </ul>

                    <div class="depart-date">
                      <div
                        class="depart-title"
                        :style="{ color: trip.Elem_Couleur }"
                      >
                        Date de depart :
                      </div>
                      <ul class="list-depart">
                        <li style="width: 100%">
                          <a :href="trip.url">
                            {{ trip.dates }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="depart-infos-bottom">
                    <span style="color: #20c6e8" class="demande-partage">{{
                      trip.demandePartage
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FavoriteList",
  watch: {
    clients() {
      this.infoCircuit = [];
      this.infoArticles = [];

      for (let i in this.clients) {
        if (this.clients[i].Validation_isUser === 1) {
          let FavorisCircuits = JSON.parse(
            this.clients[i].Favoris_Circuits_Cards
          );
          let keys = Object.keys(FavorisCircuits);
          let FavorisArticles = JSON.parse(
            this.clients[i].Favoris_Articles_Cards
          );
          let keys2 = Object.keys(FavorisArticles);
          let newIndex = keys.length - 1;
          let oldIndex;
          for (let k in keys) {
            if (keys === "autres") {
              oldIndex = k;
            }
          }
          keys.splice(newIndex, 0, keys.splice(oldIndex, 1)[0]);
          for (let j in keys) {
            this.infoCircuit.push({
              titre: keys[j],
              trip: FavorisCircuits[keys[j]],
            });
          }
          for (let k in keys2) {
            this.infoArticles.push({
              titre: keys2[k],
              trip: FavorisArticles[keys2[k]],
            });
          }
          this.propositionCircuit = JSON.parse(
            this.clients[i].Propositions_Circuits_Cards
          );
          this.propositionArticles = JSON.parse(
            this.clients[i].Propositions_Articles_Cards
          );
          this.propositionDerniere = JSON.parse(
            this.clients[i].Propositions_DernieresChances_Cards
          );
        }
      }
    },
  },
  data: () => ({
    classSelect: {
      circuits: "item-tabs-menu active-tabs",
      articles: "item-tabs-menu",
      also: "item-tabs-menu",
    },
    infoCircuit: [],
    infoArticles: [],
    propositionCircuit: [],
    propositionArticles: [],
    propositionDerniere: [],
    mode: "circuits",
  }),
  computed: {
    ...mapState({
      clients: (state) => state.client.list,
    }),
  },
  methods: {
    ...mapActions(["getClients"]),
    changeMode(type) {
      this.mode = type;
      this.classSelect.also = "item-tabs-menu";
      this.classSelect.articles = "item-tabs-menu";
      this.classSelect.circuits = "item-tabs-menu";
      this.classSelect[type] = "item-tabs-menu active-tabs";
    },
    changeUrl(url) {
      console.log(url);
      window.location = url;
    },
  },
  mounted() {
    this.getClients();
  },
};
</script>
<style lang="css" scoped>
.container {
  padding-bottom: 10px;
}
</style>
